module.exports = __webpack_public_path__ + "2a042f50aebb273163c66ea8c7e92610.pdf";